import { render, staticRenderFns } from "./Teacherpop.vue?vue&type=template&id=1ff8d8ef"
import script from "./Teacherpop.vue?vue&type=script&lang=js"
export * from "./Teacherpop.vue?vue&type=script&lang=js"
import style0 from "./Teacherpop.vue?vue&type=style&index=0&id=1ff8d8ef&prod&lang=less"
import style1 from "./Teacherpop.vue?vue&type=style&index=1&id=1ff8d8ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports